export default __webpack_public_path__ + "static/media/logo.3874d1cc.svg";